module.exports = __webpack_public_path__ + "static/img/bg-pt.c47ed660.png";